import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import Field from "designV2/components/Field";
import Button from "designV2/components/Button";
import "./orderModals.css";

const REJECT = gql`
  mutation rejectOrderByShopAdmin($orderId: ID!, $rejectedFor: OrderRejectedFor!) {
    rejectOrderByShopAdmin(orderId: $orderId, rejectedFor: $rejectedFor) {
      _id
    }
  }
`;

const REASON_OPTIONS = [
  { value: "packingDamaged", label: "Packing damaged" },
  { value: "damagedForPacking", label: "Damaged for packing" },
  { value: "differentProduct", label: "Different product" },
  { value: "noReceiver", label: "No receiver" },
  { value: "deliveryWasNotAccepted", label: "Delivery was not accepted" },
];

const readableError = (error) => {
  if (!error) return "";
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    return error.graphQLErrors[0].message;
  }
  return error.message || "Something went wrong, please try again.";
};

const RejectOrder = ({ orderId, close }) => {
  const [reason, setReason] = useState(REASON_OPTIONS[0].value);
  const [error, setError] = useState("");

  const [rejectOrderByShopAdmin, { loading }] = useMutation(REJECT);

  const onSubmit = () => {
    if (loading) return;
    setError("");
    rejectOrderByShopAdmin({ variables: { orderId, rejectedFor: reason } })
      .then(() => close())
      .catch((err) => setError(readableError(err)));
  };

  return (
    <div className="orderModalBody">
      <Field label="Reason" htmlFor="rejectReason">
        <select id="rejectReason" className="dsInput" value={reason} onChange={(e) => setReason(e.target.value)}>
          {REASON_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </Field>

      {error && (
        <div className="dsFormMessage error" role="alert">
          {error}
        </div>
      )}

      <div className="orderModalActions">
        <Button onClick={close}>Cancel</Button>
        <Button variant="danger" onClick={onSubmit} loading={loading}>
          Reject order
        </Button>
      </div>
    </div>
  );
};

export default RejectOrder;
